import type { TFetchSuggestions } from '../models';

export const fetchSuggestionsFullName: TFetchSuggestions = ({
    fetchFirstName,
    fetchLastName,
    fetchPatronymic,
    fullName = '',
    isFirstFetchSuggestions,
    setStateOldNames,
    stateOldNames,
}) => {
    const [lastName, firstName = '', patronymic = ''] = fullName.split(' ');
    let { oldFirstName, oldLastName, oldPatronymic } = stateOldNames;

    if (stateOldNames.oldLastName !== lastName || isFirstFetchSuggestions) {
        fetchLastName(lastName);
        oldLastName = lastName;
    }

    if (stateOldNames.oldFirstName !== firstName || isFirstFetchSuggestions) {
        fetchFirstName(firstName);
        oldFirstName = firstName;
    }

    if (stateOldNames.oldPatronymic !== patronymic || isFirstFetchSuggestions) {
        fetchPatronymic(patronymic);
        oldPatronymic = patronymic;
    }

    setStateOldNames(prevState => {
        return {
            ...prevState,
            oldLastName,
            oldFirstName,
            oldPatronymic,
        };
    });
};
